// eslint-disable-next-line @tseslint/typedef
export const IMAGE_FORMATS = {
  png: "png",
  jpeg: "jpeg",
  webp: "webp",
  avif: "avif"
} as const;
export type ImageFormat = typeof IMAGE_FORMATS[keyof typeof IMAGE_FORMATS];

const IMAGE_FORMATS_COLLECTION: ImageFormat[] = Object.values(IMAGE_FORMATS);

function buildBase64ImagePrefix (format: ImageFormat): string {
  return `data:image/${ format };base64,`;
}

export function parseBase64ToImage (value: string, format: ImageFormat): string {
  const prefix: string = buildBase64ImagePrefix(format);

  if (value.startsWith(prefix))
    return value;

  if (value)
    return `${ prefix }${ value }`;


  return "";
}
export function removeImagePrefixFromBase64 (base64Image: string, format: ImageFormat): string {
  return base64Image.replace(buildBase64ImagePrefix(format), "");
}
export function getBase64ImageFormat (value: string): ImageFormat | undefined {
  return IMAGE_FORMATS_COLLECTION.find((format: string) => value.includes(format));
}
